const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "/api"
    : process.env.REACT_APP_BACKEND_URL; // Vercel rewrite will work in production

export default API_BASE_URL;
